<template>
  <div id="main-header">
    <nav class="main-nav container">
      <div class="nav-wrapper">
        <img
          class="logo"
          src="@/assets/img/upmood_icon.png"
          alt="Emotion Sensor & Mood Tracker"
          @click="$router.push('/').catch(() => {})"
        />
        <div class="nav-links">
          <span class="product" @click="openChildren = !openChildren"
            >Products</span
          >
          <router-link to="/HowItWorks">How it works</router-link>
          <router-link to="/Features">App</router-link>
          <!-- <a :href="moodmixUrl" target="_blank">Moodmix</a> -->
          <!-- <router-link
            to="/BuyNow"
            v-if="$route.name !== 'buynow' && $route.name !== 'order'"
            >Buy Band</router-link
          >

          <router-link
            :to="{ name: 'order', query: { item: 'watch' } }"
            v-if="$route.name !== 'order'"
            >Buy Watch</router-link
          > -->
        </div>
        <a
          href="https://www.upmooddesignlab.com/shop"
          target="_blank"
          class="store"
          >Store</a
        >
      </div>
      <div class="product-wrapper" v-if="openChildren">
        <img src="@/assets/img/Group 112.png" alt="band" @click="gotoBand" />
        <img src="@/assets/img/Group 111.png" alt="watch" @click="gotoWatch" />
      </div>
    </nav>

    <nav class="mobile-nav" v-show="mobileNavIsActive">
      <div class="logo-wrapper">
        <span class="close-nav" @click="toggleMobileNav">&#10006;</span>
        <img
          class="logo"
          src="@/assets/img/upmood_icon.png"
          alt="upmood logo"
          @click="$router.push('/').catch(() => {})"
        />
      </div>
      <div class="nav-links">
        <div class="product-label">
          <div class="label" @click="openChildrenMobile = !openChildrenMobile">
            <span>Products</span>
            <span class="toggle-nav">{{ openChildrenMobile ? "-" : "+" }}</span>
          </div>
          <div class="mobile-product-wrapper" v-if="openChildrenMobile">
            <img
              src="@/assets/img/Group 112.png"
              alt="band"
              @click="changeRoute('BuyNow')"
            />
            <img
              src="@/assets/img/Group 111.png"
              alt="watch"
              @click="changeRoute('Watch')"
            />
          </div>
        </div>
        <span @click="changeRoute('HowItWorks')">How it works</span>
        <span @click="changeRoute('Features')">App</span>
        <!-- <a :href="moodmixUrl" target="_blank">Moodmix</a> -->
        <a href="https://www.upmooddesignlab.com/shop" target="_blank">Store</a>
      </div>

      <footer>
        <a href="https://www.facebook.com/UpmoodApp" target="blank"
          ><img src="@/assets/img/facebook.svg" alt="facebook"
        /></a>
        <a href="https://twitter.com/Upmoodapp" target="blank"
          ><img src="@/assets/img/twitter.svg" alt="twitter"
        /></a>
        <a href="https://www.instagram.com/upmoodapp" target="blank"
          ><img src="@/assets/img/instagram.svg" alt="instagram"
        /></a>
        <p>&copy; 2021, Taison Digital. All rights reserved</p>
      </footer>
    </nav>

    <div class="menu" @click="toggleMobileNav" v-show="!mobileNavIsActive">
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mobileNavIsActive: false,
      openChildren: false,
      openChildrenMobile: false
      //   moodmixUrl: process.env.VUE_APP_MOODMIX_URL
    };
  },

  methods: {
    togglePreOrder() {
      this.$store.dispatch("preOrder/togglePreOrder", true);
    },

    toggleMobileNav() {
      this.mobileNavIsActive = !this.mobileNavIsActive;
      this.$parent.mobileNav = !this.$parent.mobileNav;
    },

    changeRoute(route) {
      this.openChildrenMobile = false;
      this.mobileNavIsActive = false;
      this.$parent.mobileNav = false;

      if (route === "Watch") {
        this.$router
          .push({ name: "order", query: { item: "watch" } })
          .catch(() => {});
      } else {
        this.$router.push(`/${route}`).catch(() => {});
      }
    },

    gotoBand() {
      this.openChildren = false;
      this.$router.push("/BuyNow").catch(() => {});
    },

    gotoWatch() {
      this.openChildren = false;
      this.$router
        .push({ name: "order", query: { item: "watch" } })
        .catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
#main-header {
  background-color: #fff;
  padding: 30px 0px 30px;
  position: fixed;
  box-shadow: 3px 1px #00000029;
  z-index: +3;
  width: 100%;
  top: 0px;

  @include mobile {
    padding-top: 20px;
    padding-bottom: 20px;
  }

  .main-nav {
    display: flex;
    flex-direction: column;
    z-index: +2;

    .nav-wrapper {
      display: flex;
      flex-direction: row;
      align-items: center;
      z-index: +2;

      .logo {
        width: 52px;
        cursor: pointer;
        margin-right: 40px;

        @include mobile {
          width: 52px;
        }
      }

      .nav-links {
        z-index: +1;

        @include mobile {
          display: none;
        }

        a,
        span {
          box-sizing: border-box;
          display: inline-block;
          padding: 10px 35px 10px 10px;
          text-decoration: none;
          font-size: 16px;
          font-weight: 500;
          font-family: $Quicksand;
          line-height: 20px;
          color: #6b7a80;
          cursor: pointer;

          &:hover {
            color: #ffe575;
          }
        }

        .toggle {
          &:hover {
            color: #ffe575;
            box-shadow: none;
          }
        }
      }

      .store {
        box-sizing: border-box;
        display: inline-block;
        padding: 10px;
        text-decoration: none;
        font-size: 16px;
        font-weight: 500;
        font-family: $Quicksand;
        line-height: 20px;
        color: #6b7a80;
        margin-left: auto;

        &:hover {
          color: #ffe575;
        }

        @include mobile {
          display: none;
        }
      }
    }

    .product-wrapper {
      margin: 80px 0px 0px 92px;

      img {
        width: 95px;
        height: 160px;
        margin-right: 120px;
        cursor: pointer;

        &:last-child {
          margin-right: 0px;
        }
      }
    }
  }

  .mobile-nav {
    display: none;

    @include mobile {
      background-color: #fff;
      z-index: 1999999;
      position: fixed;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      display: flex;
      flex-direction: column;
    }

    .logo-wrapper {
      position: relative;
      padding: 20px;
      background-color: #fff;
      box-shadow: 3px 1px #00000029;

      .close-nav {
        position: absolute;
        right: 20px;
        top: 30px;
        color: #6b7a80;
        font-size: 20px;
        cursor: pointer;
      }

      .logo {
        width: 52px;
        cursor: pointer;
      }
    }

    .nav-links {
      display: flex;
      flex-direction: column;
      height: 100%;
      width: 100%;
      background-color: #fff;
      padding: 30px;

      > * {
        font-size: 16px;
        font-weight: 500;
        border-bottom: 1px solid #ebebeb;
      }

      a,
      span {
        font-family: $Quicksand;
        display: inline-block;
        padding: 20px 0px;
        text-decoration: none;
        line-height: 20px;
        color: #6b7a80;
        cursor: pointer;
      }

      .product-label {
        position: relative;
        cursor: pointer;

        .toggle-nav {
          position: absolute;
          top: 0px;
          right: 0px;
          font-size: 21px;
        }
      }

      .mobile-product-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 20px;
        margin-top: 5px;
        box-shadow: 0px 4px 3px #00000029;

        img {
          width: 80px;
          height: 150px;
          margin-bottom: 30px;
          cursor: pointer;

          &:last-child {
            margin-bottom: 0px;
          }
        }
      }
    }

    footer {
      text-align: left;
      color: #6b7a80;
      background-color: #fff;
      width: 100%;
      padding: 0px 30px;

      img {
        margin: 0 5px;
      }

      p {
        margin: 20px 0;
        font-size: 14px;
      }
    }
  }

  .menu {
    display: none;
    z-index: +2;
    cursor: pointer;
    position: absolute;
    top: 30px;
    right: 20px;

    span {
      display: block;
      margin: 2px 0;
      width: 18px;
      border: 1px solid #6b7a80;
      border-radius: 20px;
    }

    @include mobile {
      display: flex;
      flex-direction: column;
    }
  }
}
</style>
